export const getAipAuthUrl = () => {
  const url = process.env.AIP_AUTH_URL;
  if (!url) {
    throw new Error('Missing env: AIP_AUTH_URL');
  }

  return url;
};
